<template>
  <v-layout row wrap>
    <!-- Rules List -->
    <v-flex :xs10="!addRuleSetsSheet" :xs5="addRuleSetsSheet">
      <v-data-table :headers="ruleSetHeaders" :items="ruleCollectionRuleSetsList" ref="draggableTable"
        :pagination.sync="pagination" :rows-per-page-items="rowsPerPagesArray">
        <template slot="items" slot-scope="props">
          <tr>
            <td class="handle" style="max-width: 28px" v-if="displayDragHandle">
              <v-icon>drag_handle</v-icon>
            </td>
            <td class="text-xs-center" v-if="displayDragHandle">{{ props.item.sequence + 1 }}</td>
            <td class="text-xs-left" :width="addRuleSetsSheet ? '' : '35%'">
              <v-btn flat icon color="primary" @click="props.expanded = !props.expanded">
                <v-icon>{{ props.expanded ? 'remove_circle' : 'add_circle' }}</v-icon>
              </v-btn>
              {{ props.item.title }}
            </td>
            <td class="text-xs-left" width="9%" v-if="!addRuleSetsSheet">{{ props.item._enabled }}
            </td>
            <td class="text-xs-left" v-if="!addRuleSetsSheet">{{ props.item._added }}</td>
            <td class="text-xs-left" v-if="!addRuleSetsSheet">{{ props.item._updated }}</td>
            <td @click.stop="stopProp" class="justify-center layout px-0">
              <!-- Delete icon -->
              <v-tooltip bottom slot="activator">
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on" @click="showDeleteRuleSetDialog(props.item)"
                    class="error--text text--lighten-1 mr-1">
                    delete
                  </v-icon>
                </template>
                <span>Delete Ruleset</span>
              </v-tooltip>
              <!-- More menu -->
              <v-menu bottom left>
                <v-tooltip bottom slot="activator">
                  <template v-slot:activator="{ on }">
                    <v-btn icon medium v-on="on" class="grey--text text--darken-2">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <span>More</span>
                </v-tooltip>
                <v-list>
                  <v-list-tile @click="openRuleSetQuickView(props.item)">
                    <v-list-tile-title>{{ messages.label.VIEW_DETAILS }}</v-list-tile-title>
                    <v-icon small right>
                      open_in_new
                    </v-icon>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-title>{{ messages.label.TEST }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="goToEditRuleSetView(props.item)">
                    <v-list-tile-title>{{ messages.label.EDIT }}</v-list-tile-title>
                    <v-icon small right>exit_to_app</v-icon>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <!-- Expanded view-->
        <template slot="expand" slot-scope="props">
          <v-data-table hide-actions hide-headers :items="props.item.items">
            <template slot="items" slot-scope="props">
              <tr class="indigo lighten-5 ml-3">
                <!-- Place empty column for the alignment with sequence -->
                <td class="text-xs-left" width="12%"></td>
                <td class="text-xs-left" :width="addRuleSetsSheet ? '' : '35%'">
                  <!-- Place holder button to fix the alignment -->
                  <v-btn flat disabled icon>
                    <v-icon small>trip_origin</v-icon>
                  </v-btn>
                  {{ props.item.title }}
                </td>
                <td class="text-xs-left" width="9%" v-if="!addRuleSetsSheet">{{ !props.item.disabled }}</td>
                <td class="text-xs-left" v-if="!addRuleSetsSheet">{{ props.item._added }}</td>
                <td class="text-xs-left" v-if="!addRuleSetsSheet">{{ props.item._updated }}</td>
                <td @click.stop="stopProp" class="justify-center layout px-0">
                  <!-- Delete icon -->
                  <!-- placehoder for alignment only -->
                  <v-icon small class="indigo--text text--lighten-5 mr-1">
                    delete
                  </v-icon>
                  <!-- More Menu -->
                  <v-menu bottom left>
                    <v-tooltip bottom slot="activator">
                      <template v-slot:activator="{ on }">
                        <v-btn icon medium v-on="on" class="grey--text text--darken-2">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <span>More</span>
                    </v-tooltip>
                    <v-list>
                      <v-list-tile @click="openRuleQuickView(props.item)">
                        <v-list-tile-title>{{ messages.label.VIEW_DETAILS }}</v-list-tile-title>
                        <v-icon small right>
                          open_in_new
                        </v-icon>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-title>{{ messages.label.COPY_TO }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="goToEditRuleView(props.item)">
                        <v-list-tile-title>{{ messages.label.EDIT }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <v-alert :value="true" color="info" class="black--text" icon="info">
                {{ messages.info.NO_RULES }}
              </v-alert>
            </template>
          </v-data-table>
        </template>
        <!-- No Data -->
        <template slot="no-data">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            {{ messages.info.NO_RULES_IN_RULESET }}
          </v-alert>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex xs7 v-show="addRuleSetsSheet">
      <AddRuleSets />
    </v-flex>
    <v-flex xs2 v-show="!addRuleSetsSheet">
      <v-btn color="primary" flat @click="showAddRuleSetsSheet()">
        <v-icon left>add_circle</v-icon><span>{{ messages.label.ADD_RULESETS }}</span>
      </v-btn>
    </v-flex>
    <!-- Dialogs -->
    <v-dialog v-model="ruleQuickViewDialog" width="1000" height="800">
      <RuleQuickView />
    </v-dialog>
    <v-dialog v-model="ruleSetQuickViewDialog" width="1000" height="800">
      <RuleSetQuickView />
    </v-dialog>
    <!-- Delete dialog -->
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="subheading ttu">
          {{ messages.label.DELETE_RULE_SET }}
        </v-card-title>
        <v-card-text>
          <p>{{ messages.info.DELETE_RULE_SET_MSG }} <b>{{ ruleSetToDelete.title }}</b> ? </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1 white--text" @click="deleteDialog = false">
            {{ messages.label.CANCEL }}
          </v-btn>
          <v-btn color="error" @click="deleteRuleSet(ruleSetToDelete)">
            {{ messages.label.DELETE }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapState, mapMutations } from "vuex"
import messages from "@/XVAT/messages.json"
import RuleQuickView from "@/XVAT/Rule/RuleQuickView"
import RuleSetQuickView from "@/XVAT/RuleSet/RuleSetQuickView"
import XVATRulesService from "@/XVAT/XVATRulesService"
import AddRuleSets from "@/XVAT/RuleCollection/AddRuleSets"
import { SET_RULECOLLECTION_RULESETS } from "@/store/constants/mutation-types"
import Sortable from "sortablejs"

export default {
  name: "RuleSetRules",
  components: {
    RuleQuickView,
    RuleSetQuickView,
    AddRuleSets
  },
  data() {
    return {
      selectedRuleSet: {},
      addRuleSetsSheet: false,
      ruleSetQuickView: false,
      ruleQuickView: false,
      rowsPerPagesArray: [10, 25],
      ruleQuickViewDialog: false,
      ruleSetQuickViewDialog: false,
      ruleSetToDelete: {},
      deleteDialog: false,
      pagination: {
        sortBy: "title",
        page: 1,
        descending: false
      }
    }
  },
  computed: {
    ...mapState("xvat", ["addRuleSetsFilters", "ruleCollectionRuleSetsList"]),
    displayDragHandle() {
      let display = false
      if (this.addRuleSetsFilters.ruleCollectionType === "TRANSFORMATION") {
        display = true
      }
      return display
    },
    ruleSetHeaders() {
      return this.getRuleSetHeaders()
    }
  },
  methods: {
    ...mapMutations("xvat", [
      SET_RULECOLLECTION_RULESETS
    ]),

    /**
     * getRuleSetHeaders - rules data table headers
     * @returns {array}
     */
    getRuleSetHeaders() {
      let headersToDisplay = []
      if (this.displayDragHandle) {
        headersToDisplay = [{
          text: "",
          align: "left",
          sortable: false
        },
        {
          text: "SEQUENCE",
          align: "center",
          value: "sequence",
          sortable: true
        }]
      }
      let commonHeaders = [{
        text: messages.label.TH_TITLE,
        sortable: true,
        align: "left",
        value: "title"
      }]
      headersToDisplay = headersToDisplay.concat(commonHeaders)
      if (this.addRuleSetsSheet) {
        headersToDisplay.push({ text: "", sortable: false })
        return headersToDisplay
      } else {
        headersToDisplay.push({
          text: messages.label.TH_ENABLED,
          sortable: true,
          align: "left",
          value: "_enabled"
        })
        headersToDisplay.push({
          text: messages.label.TH_ADDED,
          value: "_added",
          sortable: true,
          align: "left"
        })
        headersToDisplay.push({
          text: messages.label.TH_UPDATED,
          value: "_updated",
          sortable: true,
          align: "left"
        })
        headersToDisplay.push({ text: "", sortable: false })
        return headersToDisplay
      }
    },

    /**
     * showAddRuleSetsSheet - Show condition details
     * @param {object} rule
     */
    showAddRuleSetsSheet() {
      this.addRuleSetsSheet = true
      XVATRulesService.$emit("event:showAddRuleSetsSheet")
    },

    /**
     * hideAddRuleSetsSheet - Hide condition details view
     */
    hideAddRuleSetsSheet() {
      this.addRuleSetsSheet = false
    },

    /**
     * resetData - Reset data
     */
    resetData() {
      this.selectedRuleSet = {}
    },

    /**
     * loadRuleSets - updated view with rules list
     */
    loadRuleSets() {
      this.resetData()
    },

    /**
     * stopProp - Do nothing, just to stop event propogation
     */
    stopProp() { },

    /**
     * showDeleteRuleSetDialog - Show dialog to delete ruleset
     * @param {object} ruleSet
     */
    showDeleteRuleSetDialog(ruleSet) {
      this.deleteDialog = true
      this.ruleSetToDelete = ruleSet
    },

    /**
    * Reset / update sequence numbers
    */
    resetRuleSetsSequenceNumbers() {
      if (this.ruleCollectionRuleSetsList.length > 0) {
        this.$lodash.forEach(this.ruleCollectionRuleSetsList, (ruleSet, index) => {
          ruleSet["sequence"] = index
        })
      }
    },

    /**
     * Sort rules within rule-set based on sequence number
     */
    sortRuleSetsOnSequence() {
      if (this.ruleCollectionRuleSetsList.length > 0) {
        let sortedList = this.$lodash.sortBy(this.ruleCollectionRuleSetsList, "sequence")
        this.SET_RULECOLLECTION_RULESETS([])
        this.$nextTick(() => {
          this.SET_RULECOLLECTION_RULESETS(sortedList)
        })
      }
    },

    /**
     * deleteCondition - Delete existing condition
     * @param {object} condition
     */
    deleteRuleSet(ruleSet) {
      let ruleSetIndex = this.$lodash.findIndex(this.ruleCollectionRuleSetsList, (ruleSetObj) => {
        return ruleSet.id === ruleSetObj.id
      })
      if (ruleSetIndex !== -1) {
        this.ruleCollectionRuleSetsList.splice(ruleSetIndex, 1)
        this.SET_RULECOLLECTION_RULESETS(this.ruleCollectionRuleSetsList)
        this.deleteDialog = false
        this.hideAddRuleSetsSheet()
      }
      this.resetRuleSetsSequenceNumbers()
      this.sortRuleSetsOnSequence()
      XVATRulesService.$emit("event:validateForUpdateRuleCollection")
    },

    /**
     * openRuleQuickView - Open rule quick view in dialog
     */
    openRuleQuickView(ruleObj) {
      this.ruleQuickViewDialog = true
      XVATRulesService.$emit("event:showRuleQuickViewDialog", ruleObj)
    },

    /**
     * closeRuleQuickView - close the dialog view of rule quick view
     */
    closeRuleQuickView() {
      this.ruleQuickViewDialog = false
    },

    /**
     * openRuleSetQuickView - Open ruleset quick view in dialog
     */
    openRuleSetQuickView(ruleSetObj) {
      this.ruleSetQuickViewDialog = true
      XVATRulesService.$emit("event:showRuleSetQuickViewDialog", ruleSetObj)
    },

    /**
     * closeRuleSetQuickView - close the dialog view of rule set quick view
     */
    closeRuleSetQuickView() {
      this.ruleSetQuickViewDialog = false
    },

    /**
     * goToEditView - Navigate to Edit view
     * @param {object} ruleSet
     */
    goToEditRuleSetView(ruleSet) {
      let id = ruleSet.id
      this.$router.push({ name: "XVATManageRuleSet", params: { id: id } })
    },

    /**
     * goToRuleEditView - Navigate to Edit view
     * @param {object} rule
     */
    goToEditRuleView(rule) {
      let id = rule.id
      this.$router.push({ name: "XVATManageRule", params: { id: id } })
    },

    /**
     * validateRuleSetRules -
     */
    validateRuleCollectionRuleSets() {
      // NOTE: For now passing "true" but might have to come back and see if we need to do
      // something else here
      XVATRulesService.$emit("event:ruleCollectionRuleSetsValidation", true)
    },

    /**
     * setPagination sorting param based on changed ruleCollectionType
     */
    setPagination(ruleCollectionType) {
      if (ruleCollectionType === "TRANSFORMATION") {
        this.pagination.sortBy = "sequence"
      } else if (ruleCollectionType === "VALIDATION") {
        this.pagination.sortBy = "title"
      }
    }
  },
  created() {
    /**
    * Non reactive properties
    */
    this.messages = messages

    /**
     * Events
     */
    XVATRulesService.$on("event:ruleCollectionDataRetrieved", this.loadRuleSets)
    XVATRulesService.$on("event:validateRuleCollectionRuleSets", this.validateRuleCollectionRuleSets)
    XVATRulesService.$on("event:hideAddRuleSetsSheet", this.hideAddRuleSetsSheet)
    XVATRulesService.$on("event:hideRuleQuickViewDialog", this.closeRuleQuickView)
    XVATRulesService.$on("event:hideRuleSetQuickViewDialog", this.closeRuleSetQuickView)
    XVATRulesService.$on("event:ruleCollectionTypeChanged", this.setPagination)
  },
  beforeDestroy() {
    XVATRulesService.$off("event:ruleSetDataRetrieved", this.loadRuleSets)
    XVATRulesService.$off("event:validateRuleCollectionRuleSets", this.validateRuleCollectionRuleSets)
    XVATRulesService.$off("event:hideAddRuleSetsSheet", this.hideAddRuleSetsSheet)
    XVATRulesService.$off("event:hideRuleQuickViewDialog", this.closeRuleQuickView)
    XVATRulesService.$off("event:hideRuleSetQuickViewDialog", this.closeRuleSetQuickView)
    XVATRulesService.$off("event:ruleCollectionTypeChanged", this.setPagination)
  },
  mounted() {
    let table = this.$refs.draggableTable.$el.getElementsByTagName("tbody")[0]
    const _self = this
    Sortable.create(table, {
      handle: ".handle", // Use handle so user can select text
      onEnd({ newIndex, oldIndex }) {
        oldIndex = oldIndex / 2
        newIndex = newIndex / 2
        const rowSelected = _self.ruleCollectionRuleSetsList.splice(oldIndex, 1)[0] // Get the selected row and remove it
        _self.ruleCollectionRuleSetsList.splice(newIndex, 0, rowSelected) // Move it to the new index
        _self.resetRuleSetsSequenceNumbers()
        _self.sortRuleSetsOnSequence()
      }
    })
  }
}
</script>
<style>
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/RuleCollection/RuleCollectionRuleSets.vue